import React from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { SkillsData } from '../../data/ApplicantsData';

import { Card, CardContent } from '@material-ui/core';
import {
  TextField,
  Select,
  Checkbox,
  InputLabel,
  MenuItem,
  FormControl,
  ListItemText,
} from '@material-ui/core';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';

import PrimaryButton from './PrimaryButton';
import './Filter.scss';

const autoCompleteFilter = createFilterOptions();

export const FilterCustom = ({ filter = [], data = [], filterClass = '' } = {}) => {
  const [positionType, setPositionType] = React.useState([]);
  const [value, setValue] = React.useState(null);

  // Handle change for select with checkbox
  const handleChange = (event) => {
    setPositionType(event.target.value);
  };

  return (
    <Card className={filterClass} variant="outlined">
      <CardContent>
        <Grid container spacing={1}>
          {filter.list?.map((itemVal, index) => (
            <Grid
              key={index}
              item
              xs={itemVal?.xs || 12}
              sm={itemVal?.sm || 12}
              md={itemVal?.md || 4}
              lg={itemVal?.lg || 2}
              xl={itemVal?.xl || 2}
            >
              <>
                {itemVal.type === 'text' && (
                  <>
                    <label className={itemVal?.labelClass}> {itemVal?.label} </label>
                    <Box pt={1}>
                      <FormControl variant={itemVal?.variant} className={itemVal?.formControlClass}>
                        <TextField
                          className={itemVal?.fieldClass}
                          label={itemVal?.placeholder}
                          variant={itemVal?.variant}
                          margin={itemVal?.margin}
                        />
                      </FormControl>
                    </Box>
                  </>
                )}

                {/* For Multi select */}
                {itemVal.type === 'multiselect' && (
                  <>
                    <label className={itemVal?.labelClass}> {itemVal?.label} </label>
                    <Box pt={1}>
                      <FormControl
                        variant={itemVal?.variant}
                        margin={itemVal?.margin}
                        className={itemVal?.formControlClass}
                      >
                        <InputLabel>{itemVal?.placeholder} </InputLabel>
                        <Select
                          className={itemVal?.fieldClass}
                          value={positionType}
                          multiple
                          onChange={handleChange}
                          renderValue={(selected) => selected.join(', ')}
                          label={itemVal?.placeholder}
                        >
                          {/* Rendering  Multiselect item */}
                          {data.map((data) => (
                            <MenuItem key={data.key} value={data.value}>
                              <Checkbox checked={positionType.indexOf(data.value) > -1} />
                              <ListItemText primary={data.label} />
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  </>
                )}

                {/* For autocomplete */}
                {itemVal.type === 'autocomplete' && (
                  <>
                    <label className={itemVal?.labelClass}> {itemVal?.label} </label>
                    <Box pt={1}>
                      <FormControl
                        variant={itemVal?.variant}
                        margin={itemVal?.margin}
                        className={itemVal?.formControlClass}
                      >
                        <Autocomplete
                          value={value}
                          size={itemVal.size}
                          className={itemVal?.fieldClass}
                          onChange={(event, newValue) => {
                            if (typeof newValue === 'string') {
                              setValue({
                                title: newValue,
                              });
                            } else {
                              setValue(newValue);
                            }
                          }}
                          // Filter values from list
                          filterOptions={(options, params) => {
                            const filtered = autoCompleteFilter(options, params);
                            return filtered;
                          }}
                          selectOnFocus
                          clearOnBlur
                          handleHomeEndKeys
                          options={SkillsData}
                          getOptionLabel={(option) => {
                            // Value selected with enter, right from the input
                            if (typeof option === 'string') {
                              return option;
                            }

                            // Add "xxx" option created dynamically
                            if (option.inputValue) {
                              return option.inputValue;
                            }

                            // Regular option
                            return option.title;
                          }}
                          renderOption={(option) => option.title}
                          freeSolo
                          renderInput={(params) => (
                            <TextField {...params} label={itemVal?.label}  variant={itemVal?.variant}/>
                          )}
                        />
                      </FormControl>
                    </Box>
                  </>
                )}
              </>
            </Grid>
          ))}

          <Grid item xs={12} sm={12} md={4} lg={2} xl={2}>
            <Box className="mt-36">
              <PrimaryButton variant="outlined" text="Filter" />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
